const RENDERS = {
    PN: 'PN.render',
    AN_UNSTANDARD: 'AN_UNSTANDARD.render',
    AN_STANDARD: 'AN_STANDARD.render',
    ANC_ADD: 'ANC_ADD.render',
    TITLE: 'TITLE.render',
    ARRAY_LINK: 'ARRAY_LINK.render',
    LEGAL: 'LEGAL.render',
    CITED: 'CITED.render',
    PRIORITY: 'PRIORITY.render',
    INPADOC: 'INPADOC.render',
    CHEMICAL: 'CHEMICAL.render',
    COMMENT: 'COMMENT.render',
    PV: 'PV.render',
    SINGLE_LINK: 'SINGLE_LINK.render',
    THUMB_120: 'THUMB_120.render',
    ABST: 'ABST.render',
    SORT_SEQ_NUM: 'SORT_SEQ_NUM.render',
    FAMILY_NUM: 'FAMILY_NUM.render',
    ICLMS: 'DEFAULT.render',
    ARRAY: 'ARRAY.render',
    CLASSIFICATION: 'CLASSIFICATION.render',
    CLASSIFICATION_MAIN: 'CLASSIFICATION_MAIN.render',
    CLASSIFICATION_TAG: 'CLASSIFICATION_TAG.render',
    COUNTRY: 'COUNTRY.render',
    MCLMS: 'MCLMS.render',
    PATENT_TYPE: 'PATENT_TYPE.render',
    TARGET_SEQUENCE: 'TARGET_SEQUENCE.render',
    TARGET_SEQUENCE_CLAIM: 'TARGET_SEQUENCE_CLAIM.render',
    TARGET_SEQUENCE_CLAIM_POSITION: 'TARGET_SEQUENCE_CLAIM_POSITION.render',
    TARGET_SEQUENCE_CLAIM_TEXT: 'TARGET_SEQUENCE_CLAIM_TEXT.render',
    EFFICIENCY_SENTENCE: 'EFFICIENCY_SENTENCE.render',
    CLAIM_COUNT: 'CLAIM_COUNT.render',
    IMAGE_COMMENTS_LAB: 'IMAGE_COMMENTS_LAB.render',
    PHS_PATENTED_DRUG: 'PHS_PATENTED_DRUG.render',
    PHS_CORE_TYPE_ID: 'PHS_CORE_TYPE_ID.render',
    PHS_CORE_DRUG_SOURCE: 'PHS_CORE_DRUG_SOURCE.render',
    TARGET_SEQUENCE_QUERY: 'TARGET_SEQ_QUERY.render',
    NEV: 'NEV.render',
    SAVED_TO_WORKSPACE: 'FOLDERS.render',
    HIT_STRUCTURE_COUNT: 'HIT_STRUCTURE_COUNT.render',
    HIT_STRUCTURE: 'HIT_STRUCTURE.render',
    HIT_STRUCTURE_MENTION: 'HIT_STRUCTURE_MENTION.render',
    HIT_STRUCTURE_CLAIM_POSITION: 'HIT_STRUCTURE_CLAIM_POSITION.render',
    HIT_STRUCTURE_CLAIM_TEXT: 'HIT_STRUCTURE_CLAIM_TEXT.render',
};
export const safeDisplayText = (text, limit) => {
    if (text && limit && text.length > limit) {
        return text.slice(0, limit).concat(' ...');
    }
    return text;
};
export function removeHTML(html) {
    if (!html) {
        return '';
    }
    const reg = /(<([^>]+)>)/gi;
    return html.replace(reg, '');
}
export default {
    PN: {
        width: 220,
        render: RENDERS.PN,
        filter: false,
    },
    AN: {
        render: RENDERS.AN_UNSTANDARD,
        width: 200,
    },
    ANC_ADD: {
        render: RENDERS.ANC_ADD,
        width: 240,
    },
    TITLE: {
        width: 300,
        render: RENDERS.TITLE,
    },
    IN: {
        render: RENDERS.ARRAY_LINK,
        width: 200,
    },
    LEGAL_STATUS: {
        render: RENDERS.LEGAL,
        width: 160,
    },
    PRIORITY: {
        render: RENDERS.PRIORITY,
        width: 400,
    },
    ANC: {
        render: RENDERS.AN_UNSTANDARD,
        width: 200,
    },
    ROOT_COMPANY_ASSIGNEE: {
        render: RENDERS.AN_STANDARD,
        width: 200,
    },
    ANS: {
        render: RENDERS.AN_STANDARD,
        width: 200,
    },
    ANCS: {
        render: RENDERS.AN_STANDARD,
        width: 200,
    },
    ROOT_COMPANY_CURRENT_ASSIGNEE: {
        render: RENDERS.AN_STANDARD,
        width: 200,
    },
    DOCDB_AN: {
        render: RENDERS.AN_UNSTANDARD,
        width: 200,
    },
    AT: {
        render: RENDERS.ARRAY_LINK,
        width: 260,
    },
    ATC: {
        render: RENDERS.ARRAY_LINK,
        width: 260,
    },
    ATCS: {
        render: RENDERS.ARRAY_LINK,
        width: 260,
    },
    IN_ST: {
        render: RENDERS.ARRAY_LINK,
        width: 260,
    },
    IPC: {
        render: RENDERS.CLASSIFICATION,
        width: 360,
    },
    IPC_M: {
        render: RENDERS.CLASSIFICATION_MAIN,
        width: 360,
    },
    LOC: {
        render: RENDERS.CLASSIFICATION,
        width: 260,
    },
    UPC: {
        render: RENDERS.CLASSIFICATION,
        width: 260,
    },
    CPC: {
        render: RENDERS.CLASSIFICATION,
        width: 360,
    },
    CPC_M: {
        render: RENDERS.CLASSIFICATION_MAIN,
        width: 360,
    },
    CPC_ALL: {
        render: RENDERS.CLASSIFICATION,
        width: 360,
    },
    GBC: {
        render: RENDERS.CLASSIFICATION,
        width: 260,
    },
    VPM_ED: {
        render: RENDERS.CLASSIFICATION_TAG,
        width: 260,
    },
    ADC: {
        render: RENDERS.CLASSIFICATION_TAG,
        width: 260,
    },
    TTC: {
        render: RENDERS.CLASSIFICATION_TAG,
        width: 260,
    },
    SEIC: {
        render: RENDERS.CLASSIFICATION_TAG,
        width: 260,
    },
    CITE_COUNT: {
        render: RENDERS.CITED,
    },
    CITED_COUNT: {
        render: RENDERS.CITED,
    },
    SIMPLE_FAMILY_COUNT: {
        render: RENDERS.INPADOC,
        width: 200,
    },
    EXTEND_FAMILY_COUNT: {
        render: RENDERS.INPADOC,
        width: 200,
    },
    INPADOC_FAMILY_COUNT: {
        render: RENDERS.INPADOC,
        width: 200,
    },
    CHEMICAL_STRUCTURE: {
        width: 150,
        render: RENDERS.CHEMICAL,
    },
    AN_ADD: {
        isLink: true,
    },
    APN: {
        render: RENDERS.FAMILY_NUM,
        width: 190,
    },
    PV: {
        render: RENDERS.PV,
    },
    APD: {
        sortable: 'custom',
        width: 100,
    },
    PBD: {
        sortable: 'custom',
        width: 100,
    },
    F_PBD: {
        width: 100,
    },
    EXPD: {
        width: 100,
    },
    WS_CREATED_AT: {
        width: 100,
    },
    ABST: {
        render: RENDERS.ABST,
        width: 600,
    },
    THUMB_120: {
        render: RENDERS.THUMB_120,
        tools: ['viewThumb', 'searchImage'],
    },
    COMMENT: {
        width: 250,
        render: RENDERS.COMMENT,
    },
    SORT_SEQ_NUM: {
        render: RENDERS.SORT_SEQ_NUM,
        width: 215,
    },
    C_STRING: {
        width: 250,
    },
    C_OPTION: {
        width: 180,
    },
    C_URL: {
        width: 160,
    },
    WS_ASSIGN_TO: {
        render: RENDERS.ARRAY,
        width: 200,
    },
    EFAM_COUNTRY: {
        render: RENDERS.COUNTRY,
        width: 200,
    },
    SIMPLE_FAMILY_COUNTRY: {
        render: RENDERS.COUNTRY,
        width: 200,
    },
    MCLMS: {
        render: RENDERS.MCLMS,
        width: 600,
    },
    PATENT_TYPE: {
        render: RENDERS.PATENT_TYPE,
        width: 100,
    },
    TARGET_SEQUENCE: {
        render: RENDERS.TARGET_SEQUENCE,
        width: 400,
    },
    TARGET_SEQUENCE_CLAIM: {
        render: RENDERS.TARGET_SEQUENCE_CLAIM,
        width: 400,
    },
    TARGET_SEQUENCE_CLAIM_POSITION: {
        render: RENDERS.TARGET_SEQUENCE_CLAIM_POSITION,
        width: 200,
    },
    TARGET_SEQUENCE_CLAIM_TEXT: {
        render: RENDERS.TARGET_SEQUENCE_CLAIM_TEXT,
        width: 400,
    },
    HIT_STRUCTURE: {
        render: RENDERS.HIT_STRUCTURE,
        width: 200,
    },
    HIT_STRUCTURE_COUNT: {
        render: RENDERS.HIT_STRUCTURE_COUNT,
        width: 200,
    },
    HIT_STRUCTURE_MENTION: {
        render: RENDERS.HIT_STRUCTURE_MENTION,
        width: 200,
    },
    HIT_STRUCTURE_CLAIM_POSITION: {
        render: RENDERS.HIT_STRUCTURE_CLAIM_POSITION,
        width: 200,
    },
    HIT_STRUCTURE_CLAIM_TEXT: {
        render: RENDERS.HIT_STRUCTURE_CLAIM_TEXT,
        width: 200,
    },
    EFFICIENCY_SENTENCE: {
        render: RENDERS.EFFICIENCY_SENTENCE,
        width: 600,
    },
    CLAIM_COUNT: {
        render: RENDERS.CLAIM_COUNT,
        width: 90,
    },
    IMAGE_COMMENTS_LAB: {
        render: RENDERS.IMAGE_COMMENTS_LAB,
        width: 90,
    },
    FI: {
        render: RENDERS.ARRAY_LINK,
        width: 260,
    },
    FTERM: {
        render: RENDERS.ARRAY_LINK,
        width: 260,
    },
    OREF_COUNT: {
        render: RENDERS.CITED,
    },
    PHS_PATENTED_DRUG: {
        render: RENDERS.PHS_PATENTED_DRUG,
        width: 194,
    },
    PHS_CORE_TYPE_ID: {
        render: RENDERS.PHS_CORE_TYPE_ID,
        width: 194,
    },
    PHS_CORE_DRUG_SOURCE: {
        render: RENDERS.PHS_CORE_DRUG_SOURCE,
        width: 194,
    },
    FAMILY_ID: {
        render: RENDERS.FAMILY_NUM,
        width: 224,
    },
    INPADOC_FAMILY_ID: {
        render: RENDERS.FAMILY_NUM,
        width: 224,
    },
    EXTEND_FAMILY_ID: {
        render: RENDERS.FAMILY_NUM,
        width: 224,
    },
    TARGET_SEQUENCE_QUERY: {
        render: RENDERS.TARGET_SEQUENCE_QUERY,
        width: 300,
    },
    NEV: {
        render: RENDERS.NEV,
        width: 260,
    },
    SAVED_TO_WORKSPACE: {
        render: RENDERS.SAVED_TO_WORKSPACE,
        width: 200,
    },
    AI_TECHNICAL_PROBLEM: {
        width: 600,
    },
    FIRST_FADL_DATE: {
        sortable: 'custom',
        width: 180,
    },
    ICLMS: {
        render: RENDERS.ICLMS,
        width: 500,
    },
};
